import React, { useState, useEffect } from 'react';
import './DateRangePicker.css'; // 기존 DatePicker의 스타일을 재사용합니다.

interface MonthPickerProps {
	value?: Date;
	onClear?: () => void;
	onChange: (date: Date) => void;
	onReset: () => void;
	onConfirm: (date: Date) => void;
}

export default function MonthPicker(props: MonthPickerProps) {
	const {
		value,
		onClear,
		onChange,
		onReset,
		onConfirm,
	} = props;

	const today = new Date();
	const initialDate = value ?? today;

	const [year, setYear] = useState<number>(initialDate.getFullYear());
	const [month, setMonth] = useState<number>(initialDate.getMonth()); // 0-11 (1월-12월)

	// 외부에서 받는 value prop이 변경되면 내부 상태도 함께 업데이트합니다.
	useEffect(() => {
		const newDate = value ?? today;
		setYear(newDate.getFullYear());
		setMonth(newDate.getMonth());
	}, [value]);

	const handleYearChange = (increment: number) => {
		setYear(prevYear => prevYear + increment);
	};

	const handleMonthSelect = (selectedMonth: number) => {
		setMonth(selectedMonth);
		// 사용자가 월을 클릭할 때마다 onChange를 호출하여 실시간으로 상위 컴포넌트에 알립니다.
		const newDate = new Date(year, selectedMonth, 1);
		onChange(newDate);
	};

	const handleConfirm = () => {
		const newDate = new Date(year, month, 1);
		onConfirm(newDate);
	};

	const handleCancel = () => {
		// '취소'는 원래 값으로 되돌리고 팝업을 닫는 동작을 합니다.
		onConfirm(initialDate);
	}
	
	const years = Array.from({ length: 200 }, (_, i) => today.getFullYear() - 100 + i);
	const months = Array.from({ length: 12 }, (_, i) => i); // 0-11

	return (
		<div className="custom-range-picker-popup single-calendar-popup">
			<div className="month-picker-container">
				<div className="calendar-header">
					<button type="button" onClick={() => handleYearChange(-1)}>{'≪'}</button>
					<select 
						value={year} 
						onChange={e => setYear(Number(e.target.value))}
						className="month-picker-year-select"
					>
						{years.map(y => 
							<option key={y} value={y}>{y}년</option>
						)}
					</select>
					<button type="button" onClick={() => handleYearChange(1)}>{'≫'}</button>
				</div>
				
				{/* 월 선택 그리드 */}
				<div 
					className="month-picker-grid"
					onDoubleClick={handleConfirm}
				>
					{months.map(m => {
						const isSelected = m === month;
						return (
							<button
								key={m}
								className={`month-picker-month ${isSelected ? 'selected' : ''}`}
								onClick={() => handleMonthSelect(m)}
							>
								{m + 1}월
							</button>
						);
					})}
				</div>
			</div>

			{/* 하단 버튼 UI */}
			<div className="calendar-btns">
				<div className="left-btns">
                    <button className="cancel" onClick={handleCancel}>취소</button>
					{onClear && (
						<button className="cancel" onClick={onClear}>비우기</button>
					)}
				</div>
				<div className="right-btns">
					<button className="reset" onClick={onReset}>이번달</button>
					<button className="confirm" onClick={handleConfirm}>확인</button>
				</div>
			</div>
		</div>
	);
}
